import { User } from '../interfaces/user.interface';

export function getUserFullName(user: User | undefined): string {
	return [user?.first_name, user?.last_name].filter(Boolean).join(' ');
}
